module.exports = __webpack_public_path__ + "img/energychile_background_hero.a0dbaabe.png";